import type { FaireProductEntity } from "../../entity_types/product";

export const p_ak5hwt8jfb: FaireProductEntity = {
  token: "p_ak5hwt8jfb",
  type: "product",
  name: "Salt and Sea 9 oz Soy Candle - Home Decor & Gifts",
  brandToken: "b_1b0f6a45",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/f9de60150c4fb3d0ba6cffbd91b1236624d2fe5063f518603854e4ef7a1e8bd5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/186100c69733e070e1fe996dc8fecfc580c03991712f00454c306f5a9b53ff6b.png",
    "https://cdn.faire.com/fastly/b79e15160dcfc51bb1af072aa1231cdd4ac7a7c5e02c8771ef4b97cdf05d1f89.jpeg",
    "https://cdn.faire.com/fastly/9c3c857820c6f524aa0f507e5be47e35ce84e8e07cab1c199fffd1227a0914bf.png",
    "https://cdn.faire.com/fastly/ac9487b82ff768e4496af5a438ad4259e9061fbb443fbd85e5f1acb8c5ee3561.png",
    "https://cdn.faire.com/fastly/fb56c478108d73cdded39c9f1d0d37c0c25f1b281a22ecbe394b05d327909fc4.png",
    "https://cdn.faire.com/fastly/9feac22d5759eb19b915d82134ec085649b66caf23e654a81aad7dcb2a70e31c.png",
    "https://cdn.faire.com/fastly/4584a8d049bfebb24deabd581b2281358c29b20f4f942f53d18f3ee1e58cdda6.png",
  ],
  priceDollars: 12,
  description:
    'Crisp, clean, and endlessly refreshing, Salt and Sea is a sophisticated blend of citrus, sea salt, and musk with a subtle hint of amber. This modern coastal scent brings an effortless elegance to any space - perfect for customers who love fresh, airy fragrances that feel timeless year-round. A proven favorite for every season, Salt and Sea adds a refined coastal touch to any home collection.\n\nSCENT NOTES:\n• Top: Sea Salt, Citrus\n• Middle: Musk\n• Base: Amber\n\nCANDLE INFO:\n• Volume: 9oz | 208g Net Weight | 2.75x2.75x3.5"\n• Burn Time: 40+ Hours\n• Wick: 100% Cotton (Lead & Zinc Free)\n• Wax: Proprietary Soy Based Wax Blend | Vegan, Non-GMO, Kosher\n• Premium Fragrance Oil\n• Gluten Free, Phthalate Free, Non-Toxic\n• Patterned label with gold foil accents\n• Made in Pittsburgh, PA\n• Style No. CJ127\n\nCategories:\nSpring Decor, Summer, Home Decor, Easter, Beach, candles wholesale, Summer Decor, Spring 2026, vintage, Easter basket, Cottagecore, Summer 2026',
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:56.930Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
